import { computed, type ComputedRef } from 'vue';
import { useFeatureFlagInstance } from './use-feature-flag-instance.ts';
import { resolveFlag } from '../resolve-flag.ts';
import {
  FLAG_REGISTRY,
  type FlagKey,
  type FlagDefinitionFor,
} from '../registry.ts';
import type { FlagDefinition, FlagValue } from '../types.ts';

export function useFeatureFlag<K extends FlagKey>(
  key: K,
): ComputedRef<FlagValue<FlagDefinitionFor<K>>> {
  const gbRef = useFeatureFlagInstance();
  const definition = FLAG_REGISTRY[key] as FlagDefinition;

  return computed(() => {
    const gb = gbRef.value;
    const rawValue = gb.getFeatureValue(key as string, definition.defaultValue);
    return resolveFlag(definition, rawValue) as FlagValue<FlagDefinitionFor<K>>;
  });
}
